const KID = "KID";

export const mapEventsToOptions = (events) => {
  return events.map((event) => ({
    value: event.id,
    label: event.description,
    kid: event.type.includes(KID),
  }));
};

export const orderEvents = (events) => {
  return events.sort((a, b) => {
    return a.description < b.description;
  });
};
